import { render, staticRenderFns } from "./goodsMechanism.vue?vue&type=template&id=377eb480&scoped=true"
import script from "./goodsMechanism.vue?vue&type=script&lang=js"
export * from "./goodsMechanism.vue?vue&type=script&lang=js"
import style0 from "./goodsMechanism.vue?vue&type=style&index=0&id=377eb480&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377eb480",
  null
  
)

export default component.exports